import { css, useTheme } from '@emotion/react'
import { useRouter } from 'next/router'

function Form({
    children,
    onSubmit,
    style,
    width,
    height,
    backgroundColor,
    className,
    shadow = true,
    ...props
}) {
    const { locale } = useRouter()
    const theme = useTheme()
    const rtl = ['ar', 'fa'].indexOf(locale) !== -1
    const formStyle = css`
        height: 100%;
        .form-body {
            display: grid;
            align-content: center;
            height: 100%;
            grid-template-columns: repeat(1, minmax(0, 1fr));
            gap: 5px;
            ${'' /* padding: 1rem; */}
        }
        .form-control {
            font-size: ${theme.fontSize.sm};
            width: 100%;
            label {
                display: block;
                margin-bottom: 0.5rem;
            }
            input,
            select,
            textarea {
                &[readonly] {
                    background-color: transparent;
                    pointer-events: none;
                    border: none;
                }
                display: block;
                width: 100%;
                border-radius: ${theme.borderRadius.default};
                border: 1px solid ${theme.colors.lightGray};
                padding: 0.375rem 0.75rem;
                line-height: 1.5;
                background-clip: padding-box;
                &:focus {
                    color: ${theme.colors.secGray};
                    background-color: ${theme.colors.white};
                    border-color: ${theme.colors.secondaryLight};
                    outline: 0;
                    box-shadow: 0 0 0 0.2rem rgb(149 163 255 / 25%);
                }
            }
            select {
                background-position: ${rtl ? 'left' : 'right'} 0.5rem center;
            }
        }
        ${style}
    `
    return (
        <div
            className={className}
            css={css`
                border-radius: ${theme.borderRadius.default};
                height: ${height};
                width: ${width};
                background-color: ${theme.colors[backgroundColor] ||
                theme.colors.mainBackground};
                ${shadow && `box-shadow: ${theme.boxShadow.md}`}
            `}
        >
            <form onSubmit={onSubmit} css={formStyle} {...props}>
                {children}
            </form>
        </div>
    )
}

export default Form
